<template>
  <svg width="18"
       height="19"
       viewBox="0 0 18 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M1.88086 8.95117H6.75879C7.76953 8.95117 8.3584 8.3623 8.3584 7.35156V2.54395C8.3584 1.99023 7.93652 1.57715 7.37402 1.57715C6.82031 1.57715 6.41602 1.98145 6.41602 2.54395V3.16797L6.60059 5.89258L4.57031 3.75684L2.05664 1.22559C1.87207 1.03223 1.63477 0.944336 1.37109 0.944336C0.773438 0.944336 0.342773 1.34863 0.342773 1.94629C0.342773 2.21875 0.448242 2.46484 0.641602 2.64941L3.16406 5.17188L5.2998 7.20215L2.55762 7.01758H1.88086C1.31836 7.01758 0.905273 7.41309 0.905273 7.97559C0.905273 8.53809 1.31836 8.95117 1.88086 8.95117ZM10.5732 17.8457C11.127 17.8457 11.5312 17.4414 11.5312 16.8789V16.167L11.3467 13.4512L13.377 15.5869L15.9434 18.1621C16.1191 18.3555 16.3652 18.4434 16.6201 18.4434C17.2178 18.4434 17.6484 18.0391 17.6484 17.4414C17.6484 17.1689 17.543 16.9316 17.3584 16.7383L14.7832 14.1719L12.6475 12.1416L15.3896 12.3262H16.1455C16.708 12.3262 17.1211 11.9219 17.1211 11.3682C17.1211 10.7969 16.708 10.3926 16.1455 10.3926H11.1885C10.1777 10.3926 9.58887 10.9814 9.58887 11.9922V16.8789C9.58887 17.4326 10.0107 17.8457 10.5732 17.8457Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'MinimizeIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
